<ng-container *ngIf="event">
  <div class="container-long-running-task-event-display" [ngClass]="'event-type-'+event.eventType" [class.can-retry-task]="canRetry" (click)="onClick()">
    <span>[{{event.updatedAt | date : 'short'}}]</span>
    <span class="m-right-5"></span>
    <span>{{event.message}}</span>
    <ng-container *ngIf="canRetry">
      <div class="text-right">Click to retry</div>
    </ng-container>
  </div>
</ng-container>